import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../../../types'
import { CmsConverterService, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TabBoxHeaderTextConverter extends CmsConverterService<TabBoxHeaderTextData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      text: formData.st_text_left ?? defaultTextInput
    }
  }
}

export const TAB_BOX_HEADER_TEXT_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TabBoxHeaderTextData>>('TabBoxHeaderTextConverter')

export interface TabBoxHeaderTextData extends ConvertedComponentData {
  text: TextInput;
}

